import { InputSwitch } from "primereact/inputswitch";
import { useEditMode } from "../contexts/EditModeContext";
import { useErrorMarking } from "../contexts/ErrorMarkingContext";

export default function EditModeSwitch() {
  const { isEditMode, setIsEditMode } = useEditMode();
  const { setErrorMarkingScope } = useErrorMarking();

  return (
    <div className="flex-container">
      <InputSwitch
        id="toggle-edit-mode"
        checked={isEditMode}
        onChange={(e) => {
          setIsEditMode(e.value);
          setErrorMarkingScope(null);
        }}
      />
      <label htmlFor="toggle-edit-mode">Tryb edycji</label>
    </div>
  );
}
